import { useQuery } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';
import { getCurrentAccount } from '../api-query/customer'

const BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL

export async function setHotwaterSavingMode(savingMode: string, session: any ) {
    let plan = 'offPeak';
    let shouldBoostForToday = false;
    if(savingMode==='Disabled') {
        plan = 'alwaysOn'
    }
    if(savingMode==='Paused') {
        shouldBoostForToday = true
    }
    if(!session?.accessToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    
    const res = await fetch(`${BFF_BASE_URL}/v1/system/hotwater/saving/mode`,
        {
            method: 'POST',
            body: JSON.stringify({ 
                siteId: getCurrentAccount()?.siteId,
                shouldBoostForToday,
                plan
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }

    return (await res.json())
}

export async function getSystemInfo(session: any) {
    if(!session?.accessToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    const { siteId, hasUsageData } = getCurrentAccount();
    if(!siteId) {
        throw new Error('Loading...')
    }
    if(hasUsageData===false) {
        return { hasUsageData }
    }
    const res = await fetch(`${BFF_BASE_URL}/v1/system/info`,
        {
            method: 'POST',
            body: JSON.stringify({ siteId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }

    return (await res.json())
}


export const useGetSystemInfo= (session: any) => {
    const {error:errorSysInfo, data: system } = useQuery( {
        queryKey: ['SystemInfo'], // key must be unique
        queryFn: ()=>getSystemInfo(session),
        staleTime: (60000 * 60)
    })

    return { errorSysInfo, system }
  };
  

